import { ref, push, set, update, remove, onValue, get } from 'firebase/database'
import { db, tref } from './firebase.js'
import { logActivity } from './activity.js'
import { receiveStock } from './products.js'

// Purchase Orders. /club/purchaseOrders. Receiving updates inventory qty.
//   {id}: { vendorId, lines:{lineId:{productId,name,qty,cost,received}},
//           status, expectedDate, notes, createdAt }
const BASE = 'club/purchaseOrders'
export const PO_STATUSES = ['Draft', 'Ordered', 'Partially Received', 'Received', 'Cancelled']
const num = (v) => (v === '' || v == null ? 0 : Number(v) || 0)

export function watchPurchaseOrders(cb) { return onValue(tref(BASE), (s) => cb(s.val() || {})) }

export async function createPO(d) {
  const node = push(tref(BASE))
  const lines = {}
  ;(d.lines || []).forEach((ln) => { const k = push(tref(`${BASE}/${node.key}/lines`)).key; lines[k] = { productId: ln.productId || null, name: String(ln.name || ''), qty: num(ln.qty), cost: num(ln.cost), received: 0 } })
  await set(node, { id: node.key, vendorId: d.vendorId || null, lines, status: 'Draft', expectedDate: d.expectedDate || '', notes: String(d.notes || '').trim(), createdAt: Date.now() })
  logActivity({ type: 'po', icon: '🧾', text: `PO created (${Object.keys(lines).length} lines)` })
  return node.key
}

export async function setPOStatus(id, status) {
  await update(tref(`${BASE}/${id}`), { status })
  logActivity({ type: 'po', icon: '🧾', text: `PO ${status.toLowerCase()}` })
}

// Stub: "email to vendor" — records the event and marks Ordered. WIRE EMAIL
// PROVIDER HERE LATER.
export async function emailPO(id) {
  await setPOStatus(id, 'Ordered')
  logActivity({ type: 'po', icon: '📧', text: 'PO emailed to vendor (stub)' })
}

export async function cancelPO(id) { await setPOStatus(id, 'Cancelled') }
export async function deletePO(id) { await remove(tref(`${BASE}/${id}`)) }

// Receive: receipts = { lineId: qtyReceivedNow }. Increments inventory and
// per-line received, then recomputes PO status (partial vs full).
export async function receivePO(id, receipts) {
  const po = (await get(tref(`${BASE}/${id}`))).val()
  if (!po) return
  const lines = po.lines || {}
  const updates = {}
  for (const [lineId, ln] of Object.entries(lines)) {
    const got = num(receipts[lineId])
    if (got > 0) {
      updates[`lines/${lineId}/received`] = num(ln.received) + got
      if (ln.productId) {
        const cur = (await get(tref(`club/products/${ln.productId}/quantity`))).val()
        await receiveStock(ln.productId, got, `PO receive`, cur)
      }
    }
  }
  await update(tref(`${BASE}/${id}`), updates)
  const after = (await get(tref(`${BASE}/${id}/lines`))).val() || {}
  const allDone = Object.values(after).every((l) => num(l.received) >= num(l.qty))
  const anyDone = Object.values(after).some((l) => num(l.received) > 0)
  await setPOStatus(id, allDone ? 'Received' : anyDone ? 'Partially Received' : po.status)
}
